import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";
const DealsLayout = () => {
     const navList = useNav();
  let {dealBottomNav, topDealNav} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={dealBottomNav} topTabs={topDealNav} />
            <Outlet />
        </div>
    )
}

export default DealsLayout;